import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import DatePicker from './DatePicker'
import { titlesRimborso } from '../settings/settings'

const DialogRimborsoPagato = ({
  open,
  handleClose,
  triggerFunction,
  rimborso,
}) => {
  const [rimborsoDatePaid, setRimborsoDatePaid] = useState()

  useEffect(() => {
    if (open) setRimborsoDatePaid(rimborso?.datePaid)
  }, [open, rimborso])

  useEffect(() => {
    if (!open) setRimborsoDatePaid()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(rimborso?._id, rimborsoDatePaid)}
      title={titlesRimborso.titlePagato}
      textUndo='Annulla'
      textConfirm='Salva'
      maxWidth='md'
    >
      {!rimborso ? (
        <Grid size={12}>Nessun rimborso selezionato.</Grid>
      ) : (
        <Grid
          container
          spacing={3}
          justifyContent='center'
          sx={{ width: '100%' }}
        >
          <Grid size={12}>
            Il presente modulo permette di aggiornare la data del pagamento del
            rimborso. Una volta pagato, il rimborso non potrà più essere
            modificato nè eliminato.
          </Grid>
          <Grid size={{ xs: 12, sm: 8, md: 6, lg: 4 }}>
            <DatePicker
              label='Data pagamento'
              value={rimborsoDatePaid}
              onChange={setRimborsoDatePaid}
            />
          </Grid>
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogRimborsoPagato
